'use client';

import { c as _c } from "react/compiler-runtime";
import { trackEcommerce } from '@svenskaspelab/nova-core/nextjs/analytics';
import { useDialog } from '@svenskaspelab/nova-foundation/nextjs/dialog';
import { removeWager } from '@svenskaspelab/poolbetting/core/frameworks/actions/wager';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { WagerId } from '@svenskaspelab/poolbetting/schema/wager';
import { Button } from '@svenskaspelab/ui/react/button';
import Help from '@svenskaspelab/ui/react/icons/Help';
import { useRouter } from 'next/navigation';
import type { ReactNode } from 'react';
type CancelWagerProps = {
  wagerId: WagerId;
  price: number;
  product: Definition['drawProducts'][number];
  isMarketplace: boolean;
  myBetsHomeUrl?: string;
};

/**
 * Component for cancel wager action.
 *
 * @param root0 Component props
 * @param root0.wagerId id for current wager
 * @param root0.price price for current wager
 * @param root0.product product for current wager
 * @param root0.isMarketplace whether the wager is a marketplace wager or not
 * @param root0.myBetsHomeUrl url for my bets home page
 * @returns Component for cancel wager action
 */
export function CancelWager(t0) {
  const $ = _c(13);
  const {
    wagerId,
    price,
    product,
    isMarketplace,
    myBetsHomeUrl
  } = t0;
  const {
    showDialog
  } = useDialog();
  const router = useRouter();
  let t1;
  if ($[0] !== myBetsHomeUrl || $[1] !== router) {
    t1 = () => {
      router.push(myBetsHomeUrl ?? "/mina-spel");
    };
    $[0] = myBetsHomeUrl;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const callbackAfterCancel = t1;
  let t2;
  if ($[3] !== callbackAfterCancel || $[4] !== isMarketplace || $[5] !== price || $[6] !== product || $[7] !== showDialog || $[8] !== wagerId) {
    t2 = event => {
      event.preventDefault();
      removeWager({
        wagerId,
        product,
        price,
        isMarketplace,
        showDialog,
        icon: <Help />,
        callbackOnDone: callbackAfterCancel,
        trackTransaction: trackEcommerce
      });
    };
    $[3] = callbackAfterCancel;
    $[4] = isMarketplace;
    $[5] = price;
    $[6] = product;
    $[7] = showDialog;
    $[8] = wagerId;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleClick = t2;
  let t3;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-layer-contrast-on-base border-stroke-medium rounded-sm border px-1 py-0.5 lg:px-0 lg:py-0"><Button type="submit" variant="ghost">Annullera</Button></div>;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== handleClick) {
    t4 = <form onSubmit={handleClick}>{t3}</form>;
    $[11] = handleClick;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}